const question = {
    dynamic: { values: ['D'] },
    balanced: { values: ['E'] },
    prudent: { resolvedProfile: 'P' },
};

export default question;
